import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const preguntaImporterSelectors = importerSelectors(
  'pregunta.importer',
);

export default preguntaImporterSelectors;
